import { useState } from "react";
import { supabase } from "./supabaseClient";

const QUESTIONS = [
  { key: "q1", icon: "⏰", text: "약속 시간을 잘 지켰나요?" },
  { key: "q2", icon: "🤝", text: "페어플레이 정신이 있었나요?" },
  { key: "q3", icon: "💬", text: "소통과 매너가 좋았나요?" },
  { key: "q4", icon: "🏟️", text: "경기 후 시설 정리를 잘 했나요?" },
  { key: "q5", icon: "⭐", text: "다시 매칭하고 싶은 팀인가요?" },
];

export default function MannerReview({
  app, myTeam, opponentTeamId, opponentTeamName, confirmedAt, onClose, onSubmitted,
}) {
  const [scores, setScores] = useState({ q1: 0, q2: 0, q3: 0, q4: 0, q5: 0 });
  const [saving, setSaving] = useState(false);
  const [error,  setError]  = useState("");
  const [done,   setDone]   = useState(false);

  const allAnswered = Object.values(scores).every((v) => v > 0);
  const total       = Object.values(scores).reduce((a, b) => a + b, 0);
  const avgScore    = allAnswered ? total / 5 : 0;

  // 스코어 미확정 / 3일 만료 판단
  const noScore   = !confirmedAt;
  const isExpired = confirmedAt &&
    new Date(confirmedAt).getTime() + 3 * 24 * 60 * 60 * 1000 < Date.now();

  const setScore = (key, val) =>
    setScores((prev) => ({ ...prev, [key]: val }));

  const submit = async () => {
    if (!allAnswered) { setError("모든 항목에 평가해주세요"); return; }
    setSaving(true); setError("");

    // 1. 매너 리뷰 저장
    const { error: insertErr } = await supabase.from("manner_reviews").insert([{
      match_id:         app.id,
      reviewer_team_id: myTeam.id,
      reviewed_team_id: opponentTeamId,
      q1: scores.q1, q2: scores.q2, q3: scores.q3, q4: scores.q4, q5: scores.q5,
      manner_score: avgScore,
    }]);

    if (insertErr) { setError("제출 중 오류: " + insertErr.message); setSaving(false); return; }

    // 2. 전체 리뷰 건수 확인 — 2건 이상일 때만 manner_avg 업데이트
    const { data: allReviews } = await supabase
      .from("manner_reviews")
      .select("manner_score")
      .eq("reviewed_team_id", opponentTeamId);

    if (allReviews?.length >= 2) {
      const newAvg =
        allReviews.reduce((sum, r) => sum + (r.manner_score || 0), 0) / allReviews.length;
      await supabase
        .from("teams")
        .update({ manner_avg: Math.round(newAvg * 10) / 10 })
        .eq("id", opponentTeamId);
    }

    setSaving(false);
    setDone(true);
    onSubmitted?.();
  };

  // ── 스코어 미확정 안내 ───────────────────────────────────────────
  if (noScore) {
    return (
      <div style={s.backdrop} onClick={onClose}>
        <div style={s.sheet} onClick={(e) => e.stopPropagation()}>
          <div style={s.header}>
            <div style={s.title}>⭐ 매너 평가</div>
            <button style={s.closeBtn} onClick={onClose}>✕</button>
          </div>
          <div style={{ textAlign: "center", padding: "32px 24px 40px" }}>
            <div style={{ fontSize: 48, marginBottom: 14 }}>📊</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#111827", marginBottom: 10 }}>
              스코어 확정 후 평가 가능해요
            </div>
            <div style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.7 }}>
              교류전 스코어가 확정된 후<br />매너 평가가 가능합니다
            </div>
            <button style={{ ...s.submitBtn, marginTop: 28, background: "#6b7280" }} onClick={onClose}>닫기</button>
          </div>
        </div>
      </div>
    );
  }

  // ── 3일 만료 안내 ────────────────────────────────────────────────
  if (isExpired) {
    return (
      <div style={s.backdrop} onClick={onClose}>
        <div style={s.sheet} onClick={(e) => e.stopPropagation()}>
          <div style={s.header}>
            <div style={s.title}>⭐ 매너 평가</div>
            <button style={s.closeBtn} onClick={onClose}>✕</button>
          </div>
          <div style={{ textAlign: "center", padding: "32px 24px 40px" }}>
            <div style={{ fontSize: 48, marginBottom: 14 }}>⏰</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#111827", marginBottom: 10 }}>
              평가 기간이 종료됐어요
            </div>
            <div style={{ fontSize: 13, color: "#6b7280", lineHeight: 1.7 }}>
              매너 평가 기간이 종료됐습니다<br />
              <span style={{ color: "#E24B4A", fontWeight: 600 }}>(교류전 확정 후 3일 이내)</span>
            </div>
            <button style={{ ...s.submitBtn, marginTop: 28, background: "#6b7280" }} onClick={onClose}>닫기</button>
          </div>
        </div>
      </div>
    );
  }

  // ── 완료 화면 ───────────────────────────────────────────────────
  if (done) {
    return (
      <div style={s.backdrop} onClick={onClose}>
        <div style={s.sheet} onClick={(e) => e.stopPropagation()}>
          <div style={s.handle} />
          <div style={{ textAlign: "center", padding: "40px 24px 48px" }}>
            <div style={{ fontSize: 56, marginBottom: 14 }}>🎉</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#111827", marginBottom: 6 }}>
              매너 평가 완료!
            </div>
            <div style={{ fontSize: 13, color: "#6b7280", marginBottom: 4 }}>
              <span style={{ color: "#E24B4A", fontWeight: 700 }}>{opponentTeamName}</span> 팀에게
            </div>
            <div style={{ fontSize: 22, color: "#f59e0b", marginBottom: 20, fontWeight: 700 }}>
              {"★".repeat(Math.round(avgScore))}{"☆".repeat(5 - Math.round(avgScore))}
              <span style={{ fontSize: 16, color: "#374151", marginLeft: 8 }}>
                {avgScore.toFixed(1)}점
              </span>
            </div>
            <button style={s.submitBtn} onClick={onClose}>확인</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={s.backdrop} onClick={onClose}>
      <div style={s.sheet} onClick={(e) => e.stopPropagation()}>
        <div style={s.handle} />

        {/* 헤더 */}
        <div style={s.header}>
          <div style={s.title}>⭐ 매너 평가</div>
          <button style={s.closeBtn} onClick={onClose}>✕</button>
        </div>

        {/* 평가 대상 */}
        <div style={s.teamLabel}>
          <span style={{ fontSize: 12, color: "#9ca3af" }}>평가 대상</span>
          <span style={{ fontSize: 15, fontWeight: 700, color: "#111827", marginLeft: 8 }}>
            {opponentTeamName}
          </span>
        </div>

        <div style={s.questionList}>
          {/* 안내 박스 */}
          <div style={s.infoBox}>
            <div style={{ fontSize: 12, fontWeight: 700, color: "#374151", marginBottom: 4 }}>
              💡 매너 점수는 2번 이상의 교류전 평가가 쌓인 후 상대팀에게 표시됩니다
            </div>
            <div style={{ fontSize: 11, color: "#6b7280", lineHeight: 1.6 }}>
              첫 번째 평가는 바로 표시되지 않아요. 서로의 부담을 줄이기 위한 크루픽의 배려예요 😊
            </div>
          </div>

          {QUESTIONS.map((q) => (
            <div key={q.key} style={s.questionBox}>
              <div style={s.questionText}>
                <span style={{ fontSize: 18 }}>{q.icon}</span>
                {q.text}
              </div>
              <div style={s.starRow}>
                {[1, 2, 3, 4, 5].map((n) => (
                  <button
                    key={n}
                    style={{ ...s.starBtn, color: scores[q.key] >= n ? "#f59e0b" : "#d1d5db" }}
                    onClick={() => setScore(q.key, n)}
                  >
                    ★
                  </button>
                ))}
                {scores[q.key] > 0 && (
                  <span style={s.starScore}>{scores[q.key]}점</span>
                )}
              </div>
            </div>
          ))}

          {allAnswered && (
            <div style={s.avgBox}>
              평균 매너 점수&nbsp;&nbsp;
              <strong style={{ color: "#f59e0b", fontSize: 18 }}>{avgScore.toFixed(1)}</strong>
              <span style={{ color: "#9ca3af" }}> / 5.0</span>
            </div>
          )}

          {error && <p style={s.errText}>{error}</p>}

          <button
            style={{ ...s.submitBtn, opacity: saving || !allAnswered ? 0.6 : 1 }}
            onClick={submit}
            disabled={saving || !allAnswered}
          >
            {saving ? "제출 중..." : "매너 평가 제출하기"}
          </button>

          <p style={s.hintText}>
            평가 내용은 상대 팀에게 점수로만 공개되며 익명으로 처리돼요
          </p>
        </div>
      </div>
    </div>
  );
}

const s = {
  backdrop:     { position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 500, backdropFilter: "blur(4px)" },
  sheet:        { width: "90%", maxWidth: 360, background: "#fff", borderRadius: 18, maxHeight: "85vh", overflowY: "auto", boxShadow: "0 8px 32px rgba(0,0,0,0.20)" },
  handle:       { display: "none" },
  header:       { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 20px 8px" },
  title:        { fontSize: 17, fontWeight: 700, color: "#111827" },
  closeBtn:     { background: "none", border: "none", fontSize: 18, color: "#9ca3af", cursor: "pointer", padding: "4px 8px" },
  teamLabel:    { padding: "10px 20px 14px", borderBottom: "1px solid #f0f1f5", display: "flex", alignItems: "center" },
  questionList: { padding: "0 20px 36px" },
  infoBox:      { margin: "16px 0 4px", padding: "12px 14px", background: "#f8fafc", borderRadius: 10, border: "1px solid #e2e8f0" },
  questionBox:  { padding: "16px 0", borderBottom: "1px solid #f5f6fa" },
  questionText: { fontSize: 14, color: "#374151", fontWeight: 500, marginBottom: 10, display: "flex", alignItems: "center", gap: 8 },
  starRow:      { display: "flex", alignItems: "center", gap: 2 },
  starBtn:      { fontSize: 30, background: "none", border: "none", cursor: "pointer", padding: "0 3px", lineHeight: 1, transition: "color 0.1s" },
  starScore:    { fontSize: 12, color: "#9ca3af", marginLeft: 8 },
  avgBox:       { textAlign: "center", padding: "14px", background: "#fffbeb", borderRadius: 10, border: "1px solid #fde68a", fontSize: 14, color: "#374151", marginTop: 18, marginBottom: 4 },
  errText:      { fontSize: 12, color: "#E24B4A", marginTop: 8 },
  submitBtn:    { width: "100%", padding: "14px", background: "#E24B4A", color: "#fff", border: "none", borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: "pointer", marginTop: 16 },
  hintText:     { fontSize: 11, color: "#b0b8c4", textAlign: "center", marginTop: 10, lineHeight: 1.6 },
};
